"use client"
import { useState, useRef, useEffect } from "react"
import { ChevronDown } from "lucide-react"
import GalleryNavItems from "./GalleryNavItems"

export default function GalleryDropdown({ galleries }: { galleries: any[] }) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const closeTimeout = useRef<NodeJS.Timeout | null>(null)

  // Close dropdown on click outside
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false)
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClick)
    } else {
      document.removeEventListener("mousedown", handleClick)
    }
    return () => document.removeEventListener("mousedown", handleClick)
  }, [isOpen])

  // Clear close timeout on unmount
  useEffect(() => {
    return () => {
      if (closeTimeout.current) clearTimeout(closeTimeout.current)
    }
  }, [])

  function handleMouseEnter() {
    if (closeTimeout.current) clearTimeout(closeTimeout.current)
    setIsOpen(true)
  }
  function handleMouseLeave() {
    closeTimeout.current = setTimeout(() => setIsOpen(false), 150)
  }

  return (
    <div
      className="relative"
      ref={dropdownRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`flex items-center space-x-1 text-sm font-medium transition-colors`}
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        type="button"
      >
        <span>Galleries</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-96 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="grid grid-cols-1 gap-1 p-2">
            <GalleryNavItems galleries={galleries} />
          </div>
        </div>
      )}
    </div>
  )
} 